export const LEGAL_JURISDICTIONS = [
  { id: 'Austria', displayValue: 'Austria', category: 'Most common' },
  { id: 'Germany', displayValue: 'Germany', category: 'Most common' },
  { id: 'Ireland', displayValue: 'Ireland', category: 'Most common' },
  { id: 'Israel', displayValue: 'Israel', category: 'Most common' },
  { id: 'Netherlands', displayValue: 'Netherlands', category: 'Most common' },
  { id: 'Norway', displayValue: 'Norway', category: 'Most common' },
  {
    id: 'Russian Federation',
    displayValue: 'Russian Federation',
    category: 'Most common',
  },
  { id: 'South Africa', displayValue: 'South Africa', category: 'Most common' },
  { id: 'Sweden', displayValue: 'Sweden', category: 'Most common' },
  { id: 'Switzerland', displayValue: 'Switzerland', category: 'Most common' },
  { id: 'United Kingdom', displayValue: 'UK', category: 'Most common' },
  {
    id: 'United Arab Emirates',
    displayValue: 'United Arab Emirates',
    category: 'Most common',
  },

  { id: 'Austria', displayValue: 'Austria', category: 'EMEA' },
  { id: 'Belgium', displayValue: 'Belgium', category: 'EMEA' },
  { id: 'Denmark', displayValue: 'Denmark', category: 'EMEA' },
  { id: 'Finland', displayValue: 'Finland', category: 'EMEA' },
  { id: 'France', displayValue: 'France', category: 'EMEA' },
  { id: 'Germany', displayValue: 'Germany', category: 'EMEA' },
  { id: 'Ireland', displayValue: 'Ireland', category: 'EMEA' },
  { id: 'Italy', displayValue: 'Italy', category: 'EMEA' },
  { id: 'Jersey', displayValue: 'Jersey', category: 'EMEA' },
  { id: 'Luxembourg', displayValue: 'Luxembourg', category: 'EMEA' },
  { id: 'Malta', displayValue: 'Malta', category: 'EMEA' },
  { id: 'Monaco', displayValue: 'Monaco', category: 'EMEA' },
  { id: 'Netherlands', displayValue: 'Netherlands', category: 'EMEA' },
  { id: 'Norway', displayValue: 'Norway', category: 'EMEA' },
  { id: 'Portugal', displayValue: 'Portugal', category: 'EMEA' },
  { id: 'South Africa', displayValue: 'South Africa', category: 'EMEA' },
  { id: 'Spain', displayValue: 'Spain', category: 'EMEA' },
  { id: 'Sweden', displayValue: 'Sweden', category: 'EMEA' },
  { id: 'Switzerland', displayValue: 'Switzerland', category: 'EMEA' },

  { id: 'Australia', displayValue: 'Australia', category: 'Asia Pacific' },
  { id: 'China', displayValue: 'China', category: 'Asia Pacific' },
  { id: 'Hong Kong', displayValue: 'Hong Kong', category: 'Asia Pacific' },
  { id: 'India', displayValue: 'India', category: 'Asia Pacific' },
  { id: 'Japan', displayValue: 'Japan', category: 'Asia Pacific' },
  { id: 'Singapore', displayValue: 'Singapore', category: 'Asia Pacific' },

  { id: 'Canada', displayValue: 'Canada', category: 'Americas' },
  {
    id: 'United States of America',
    displayValue: 'United States of America',
    category: 'Americas',
  },
];
